module.exports = __webpack_public_path__ + "static/media/22a.e5a92458.jpg";